import React from 'react'

import { ButtonLink } from '@/legacy-src/components/ui/button'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import Icon from '../icons/Icon'

const NotAcceptingNewBanner: React.FC = () => {
  const { t } = getTranslate()

  return (
    <div className="mb-6 justify-between rounded-2xl bg-pink-500 px-9 py-6 text-center tablet:flex tablet:text-left">
      <div className="tablet:flex">
        <Icon icon="calendar-rebrand" size="slg" />
        <div className="my-2 tablet:mx-6 tablet:my-0 tablet:text-left">
          <div className="font-bold">{t('component.hiddenTherapists.notAccepting')}</div>
          <div className="text-sm">{t('component.hiddenTherapists.findOther')}</div>
        </div>
      </div>
      <ButtonLink size="small" href="/diagnosis" className="w-full hover:no-underline tablet:max-w-max">
        {t('component.messages.empty.button')}
      </ButtonLink>
    </div>
  )
}

export default NotAcceptingNewBanner
